import React from "react";



export default function Button(props: React.ComponentPropsWithRef<"div">) {
    const { children, className, ...othersProps } = props;

    return (
        <div {...othersProps} className={`button-appointment-type ${className ? className : ""}`}>
            {children}
        </div>
    )
}